/**
 * Empty dashboard shape when no client is selected or API data is not loaded.
 * Replaces the removed dashboardMock.js demo dataset.
 */

import { PULSE_CARD_DEFINITIONS } from "../lib/utils/pulseCardReport"

const EMPTY_SENTIMENT = {
  positive: 0,
  neutral: 0,
  negative: 0,
  mixed: 0,
  unknown: 0,
}

export const EMPTY_PERIOD_TOTALS = {
  impressions: 0,
  engagements: 0,
  followerDelta: 0,
  postsPublished: 0,
  linkClicks: 0,
  reach: 0,
  saves: 0,
  videoViews: 0,
  shares: 0,
  messages: 0,
  alerts: 0,
  sentiment: { ...EMPTY_SENTIMENT },
}

const EMPTY_PAID_TOTALS = {
  spend: 0,
  revenue: 0,
  roas: 0,
  impressions: 0,
  clicks: 0,
  conversions: 0,
}

function emptyPulseCard(id, title, subLabel) {
  return {
    id,
    title,
    subLabel,
    value: "0",
    definition: PULSE_CARD_DEFINITIONS[id] || "",
    trophyInsight: "",
    platformBreakdown: null,
    sparklineData: [],
    sparklineTrend: "flat",
    sparklinePercentChange: 0,
    goalProgress: null,
    detailRows: [],
  }
}

export const EMPTY_DASHBOARD_DATA = {
  platforms: ["instagram", "facebook", "linkedin", "twitter", "tiktok"],
  competitors: [
    { id: "riviera-grand", name: "Riviera Grand" },
    { id: "ocean-vista", name: "Ocean Vista" },
    { id: "harbor-heights", name: "Harbor Heights" },
    { id: "palm-resort", name: "Palm Resort" },
    { id: "cityline-hotel", name: "Cityline Hotel" },
  ],
  combinedSeries: [],
  platformSeries: {},
  ranges: {
    last30: { start: null, end: null },
    previous30: { start: null, end: null },
    yoy30: { start: null, end: null },
  },
  monthlySocialColumns: [],
  monthlySocialRows: [],
  monthlySocialRowsBySource: { all: [], organic: [], paid: [] },
  audienceAgeGender: [],
  audienceTopCities: [],
  audienceTopCountries: [],
  audienceDemographicsByPlatform: {
    all: { ageGender: [], geographic: [], languages: [] },
    instagram: null,
    facebook: null,
    linkedin: null,
    twitter: null,
    tiktok: null,
  },
  topPostsData: [],
  monitoringSeries: [],
  monitoringShare: [],
  monitoringSharePrevious: [],
  sentimentSeries: [],
  sentimentShare: [],
  sentimentKeywordsPositive: [],
  sentimentKeywordsNegative: [],
  alertsSeries: [],
  timeOfDayMessages: [],
  timeOfDayAlerts: [],
  messageHeatmapHours: [],
  messageHeatmapDays: [],
  messageHeatmapValues: [],
  socialPerformanceRows: [],
  competitorDaily: [],
  liveNowCards: [
    emptyPulseCard("inbox", "Inbox Health", "Inbound messages"),
    emptyPulseCard("engagement", "Engagement", "Total actions"),
    emptyPulseCard("campaign", "Published Posts", "Published"),
    emptyPulseCard("growth", "Total Followers", "Net growth"),
  ],
  paidMedia: {
    series: [],
    seriesByPlatform: {},
    totals: { ...EMPTY_PAID_TOTALS },
    totalsByPlatform: {},
    previousTotals: { ...EMPTY_PAID_TOTALS },
    previousTotalsByPlatform: {},
    byChannel: [],
    topAds: [],
  },
  totals: {
    last30: { ...EMPTY_PERIOD_TOTALS, sentiment: { ...EMPTY_SENTIMENT } },
    previous30: { ...EMPTY_PERIOD_TOTALS, sentiment: { ...EMPTY_SENTIMENT } },
  },
  topStoriesData: [],
}
